/*
 * Public API Surface of lib
 */

export * from './i18n.interceptor';
